<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      :collapse-transition="false"
      mode="vertical"
    >
      <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
    console.log(window.location.host)
    if(window.location.host!='service.jsyalian.cn' && window.location.host!='192.168.10.80:88'){
      document.getElementsByTagName('body')[0].style.setProperty('--menuHover', '#729167')
      document.getElementsByTagName('body')[0].style.setProperty('--menuBg', '#C6494C') //#365955
      // document.getElementsByTagName('body')[0].style.setProperty('--menuText', '#333')
      document.getElementsByTagName('body')[0].style.setProperty('--subMenuBg', '#1C2D1B')
    }






  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue